// providers
export const YOUTUBE = 'YOUTUBE';
export const VIMEO = 'VIMEO';
export const ALL = 'ALL';
// sort
export const NAME_AZ = 'NAME_AZ';
export const NAME_ZA = 'NAME_ZA';
export const OLD = 'OLD';
export const NEW = 'NEW';
// pagination
export const PREV_PAGE = 'PREV_PAGE';
export const NEXT_PAGE = 'NEXT_PAGE';
// alert places
export const HERO = 'HERO';
export const LIST = 'LIST';
// view
export const TILES_VIEW = 'TILES_VIEW';
export const LIST_VIEW = 'LIST_VIEW';
